import { gql } from '@apollo/client';

export const RENAME_TEMPLATE = gql`
  mutation renameTemplate($id: ID!, $name: String) {
    updateEditor_templates(input: { id: $id, fields: { name: $name } }) {
      editor_templates {
        objectId
        name
      }
    }
  }
`;

export const RENAME_TEMPLATE_DEFAULT = gql`
  mutation renameTemplateDefault($id: ID!, $name: String) {
    updateEditor_templates_default(
      input: { id: $id, fields: { name: $name } }
    ) {
      editor_templates_default {
        objectId
        name
      }
    }
  }
`;

export const DELETE_TEMPLATE = gql`
  mutation deleteTemplate($id: ID!) {
    deleteEditor_templates(input: { id: $id }) {
      editor_templates {
        objectId
      }
    }
  }
`;

export const DELETE_TEMPLATE_DEFAULT = gql`
  mutation deleteTemplateDefault($id: ID!) {
    deleteEditor_templates_default(input: { id: $id }) {
      editor_templates_default {
        objectId
      }
    }
  }
`;

export const REMOVE_TEMPLATE_PAGE = gql`
  mutation removeTemplatePage($id: ID!, $pageId: ID!) {
    updateEditor_templates(
      input: {
        id: $id
        fields: { editor_templates_pages: { remove: [$pageId] } }
      }
    ) {
      editor_templates {
        objectId
      }
    }
  }
`;

export const REMOVE_TEMPLATE_DEFAULT_PAGE = gql`
  mutation removeTemplateDefaultPage($id: ID!, $pageId: ID!) {
    updateEditor_templates_default(
      input: {
        id: $id
        fields: { editor_templates_default_pages: { remove: [$pageId] } }
      }
    ) {
      editor_templates_default {
        objectId
      }
    }
  }
`;

export const DELETE_TEMPLATE_PAGE = gql`
  mutation deleteTemplatePage($id: ID!) {
    deleteEditor_templates_pages(input: { id: $id }) {
      editor_templates_pages {
        objectId
      }
    }
  }
`;

export const DELETE_TEMPLATE_DEFAULT_PAGE = gql`
  mutation deleteTemplateDefaultPage($id: ID!) {
    deleteEditor_templates_default_pages(input: { id: $id }) {
      editor_templates_default_pages {
        objectId
      }
    }
  }
`;
